/**
 * Set insured auto-complete in IME Form.
 */
export default function insuredAutoComplete() {
	setInsuredAutoComplete();
}

/**
 * Enable Insured auto-complete on IME Form.
 */
function setInsuredAutoComplete() {
	window.mce = 'mce' in window ? window.mce : {};
	var $insuredInput = $( '.name-insured' ).find( 'input' );

	$insuredInput.autocomplete({
		source: function( request, response ) {
			$.ajax({
				url: `${window.mce.api_url}insureds`,
				type: 'get',
				data: {
					input: request.term
				},
				success: function( data ) {
					response( data );
				}
			});
		},
		minLength: 2
	});
}

